import {
  UIDAPresentationTypeEnum,
  UIDAStructureTypeEnum,
  getLoginAssets,
  TypeOfApplicationLink,
  KuxFilteredCategoriesDTO,
  ButtonTypes,
} from '@kaltura-ott/tvpil';
import { action, observable } from 'mobx';
import { lastValueFrom } from 'rxjs';

import { errorHandling } from '../../../utils/error-handling';
import { ErrorPriority } from '../../error';

interface LoginAssetType {
  id: number;
  title: string;
  inAppLink: string;
  typeOfAppLink: TypeOfApplicationLink;
  image: string;
  type: ButtonTypes;
}

/**
 * @category Store
 */
export class LoginStore {
  static moduleName = 'LoginStore';

  @observable isReady = false;
  @observable items: LoginAssetType[] = [];

  type: UIDAStructureTypeEnum.widget = UIDAStructureTypeEnum.widget;
  subtype: UIDAPresentationTypeEnum.login = UIDAPresentationTypeEnum.login;

  id: number;
  collectionId: number;
  image: string;
  uiDesignElements: KuxFilteredCategoriesDTO['uiDesignElements'];

  constructor(loginTree: KuxFilteredCategoriesDTO) {
    this.id = loginTree.id;
    this.collectionId = loginTree.channels[0];
    this.image = loginTree.images.length > 0 ? `${loginTree.images[0].url}/height/0/width/0` : '';
    this.uiDesignElements = loginTree.uiDesignElements;
  }

  @action
  @errorHandling({ type: ErrorPriority.high })
  async init() {
    this.items = await lastValueFrom(getLoginAssets(this.collectionId));
    this.isReady = true;
  }
}
